import { TbBoxModel2 } from "react-icons/tb"; 
import React from 'react';
import './css/Sidebar.css';
import { useNavigate } from 'react-router-dom'; 
import { TbCertificate } from "react-icons/tb";
import { IoPeople } from "react-icons/io5";
import { MdSchool } from "react-icons/md";




const Sidebar = () => {
    const navigate = useNavigate(); 
    let id_instituicao = localStorage.getItem('id_instituicao');
    return (
        <nav className="sidebar-container">
            <div className="sidebar-list">
                {id_instituicao === 'b4440c4a-daee-4b82-becf-5e2b7e50e3fd' && (
                    <div className="sidebar-item" onClick={() => navigate("/usuarios-adm")}>
                    <IoPeople className="sidebar-icon" />
                    <span>Usuários</span>
                    </div>
                )}
                {id_instituicao === 'b4440c4a-daee-4b82-becf-5e2b7e50e3fd' && (
                    <div className="sidebar-item" onClick={() => navigate("/instituicao-adm")}>
                    <MdSchool  className="sidebar-icon" />
                    <span>Escolas</span>
                    </div>
                )}
        
                <div className="sidebar-item" onClick={() => navigate("/list-modelo")}>
                    <TbBoxModel2 className="sidebar-icon" />
                    <span>Modelos</span>
                </div>
                <div className="sidebar-item" onClick={() => navigate("/emitir-certificado")}>
                    <TbCertificate className="sidebar-icon" />
                    <span>Certificados</span>
                </div>
            
                

            </div>
        </nav>
    );
};

export default Sidebar;
